export function sumAndFormat(a: string, b: string) {
  const numA = parseFloat(a)
  const numB = parseFloat(b)

  if (isNaN(numA) || isNaN(numB)) {
    return '' // Hatalı giriş varsa boş string döndür
  }

  const sum = numA + numB
  return sum.toFixed(2) // Ondalık gösterim
}